import styled from 'styled-components';
import DefaultModal from 'components/shared/Modal';

export const Modal = styled(DefaultModal)`
  ._modalContainer {
    padding: 0;
    width: 510px;
    max-width: 510px;
    height: 550px;
    max-height: 100vh;
  }
`;
export const Container = styled.div`
  padding: 10px 10px 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const Content = styled.div`
  color: #000;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  > h3 {
    font-family: ${({ theme }) => theme.font.fontFamily.bold};
    color: ${({ theme }) => theme.font.color.primary};
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    svg {
      margin-right: 12px;
      width: 40px;
      height: 40px;
    }
  }

  > textarea {
    width: 400px;
    border: 1px solid ${({ theme }) => theme.font.color.primary};
    height: 18vh;
    overflow-y: auto;
    resize: none;
  }

  > button {
    max-width: 185px;
    height: 43px;
    align-items: center;
    justify-content: center;
  }
`;
export const Close = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  > button {
    border: none;
    background: transparent;
  }
`;

export const Alert = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Card = styled.div`
  display: flex;
  justify-content: space-between;
  border: 1px solid ${({ theme }) => theme.font.color.primary};
  height: 100px;
  border-radius: 7px;
  margin-bottom: 20px;

  div {
    width: 100%;
    display: flex;
    flex-direction: column;
    color: ${({ theme }) => theme.font.color.primary};

    h1 {
      font-size: 16px;
      font-family: ${({ theme }) => theme.font.fontFamily.bold};
      color: ${({ theme }) => theme.font.color.primary};
      position: relative;
      top: 0.5rem;
      left: 1rem;
    }

    p {
      font-size: 12px;
      margin-top: 10px;
      color: #000000;
      position: relative;
      left: 1rem;
      width: 75%;
    }
  }

  button {
    max-height: 35px;
    max-width: fit-content;
    font-size: 10px;
    padding: 5px 20px;
    margin: 20px 10px 20px 0px;
  }

  @media screen and (max-width: 920px) {
    p {
      font-size: 11px;
    }
  }
`;

export const CardImage = styled.div`
  width: 190px !important;
  height: 98px;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.font.color.primary};

  img {
    width: 46.51px;
    height: 47.49px;
    display: block;
    margin: 1.6rem auto;
  }
`;
